import * as tsx from 'vue-tsx-support';

import { JtnUiTypography } from '@jtnews/jtn-ui';
import { injectStylesMixin } from '@jtnews/shared';

import styles from './record-advertising-info.styles.scss?module';

export default tsx.componentFactory.mixin(injectStylesMixin(styles)).create({
  name: 'RecordAdvertisingInfo',
  props: {
    data: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShow: false
    };
  },
  computed: {
    text(): string {
      if (this.data.length) {
        return this.data;
      }
      return '';
    }
  },
  mounted() {
    this.isShow = true;
  },
  render() {
    return (
      <JtnUiTypography
        class={styles.recordAdvertisingInfo}
        tag={'p'}
        type={'font-vijet-type-3'}
        itemscope
        itemprop="about"
        itemtype="https://schema.org/Thing"
      >
        <span itemprop="name">{this.text}</span>
      </JtnUiTypography>
    );
  }
});
